import { MapControl } from "@nextgis/react-ngw-map";

import { ToolIdentify } from "./map-identification/ToolIdentify";
import { ToolMeasure } from "./map-tools/ToolMeasure";
import { ToolZoom } from "./map-tools/ToolZoom";

import "./MapTools.css";

const TOOL_SWITCH = "map-tools-switch";

export function MapTools({
  identifyActive,
  onIdentifyChange,
}: {
  identifyActive: boolean;
  onIdentifyChange: (active: boolean) => void;
}) {
  return (
    <MapControl
      id="map-tools"
      position="bottom-left"
      order={30}
      orientation="horizontal"
      gap={8}
      margin
      addClass="map-tools"
      disableOnSecondClick={false}
    >
      <ToolIdentify
        order={5}
        active={identifyActive}
        switch={TOOL_SWITCH}
        addClass="map-tool-button"
        addClassOn="is-active-tool"
        onActiveChange={onIdentifyChange}
      />
      <ToolZoom
        order={10}
        switch={TOOL_SWITCH}
        addClass="map-tool-button"
        addClassOn="is-active-tool"
      />
      <ToolZoom
        order={20}
        out
        switch={TOOL_SWITCH}
        addClass="map-tool-button"
        addClassOn="is-active-tool"
      />
      <ToolMeasure
        type="LineString"
        order={30}
        switch={TOOL_SWITCH}
        addClass="map-tool-button"
        addClassOn="is-active-tool"
      />
      <ToolMeasure
        type="Polygon"
        order={40}
        switch={TOOL_SWITCH}
        addClass="map-tool-button"
        addClassOn="is-active-tool"
      />
    </MapControl>
  );
}
